import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const SIZES = { default: 14, link: 44, view: 118, play: 118 };
const STYLE = {
  default: "border border-white/80 bg-transparent",
  link: "border border-brand bg-brand/10",
  view: "bg-white text-sink",
  play: "bg-brand text-white",
};

export const Cursor = () => {
  const [on, setOn] = useState(false);
  const [state, setState] = useState("default");
  const x = useMotionValue(-200);
  const y = useMotionValue(-200);
  const sx = useSpring(x, { stiffness: 320, damping: 32 });
  const sy = useSpring(y, { stiffness: 320, damping: 32 });

  useEffect(() => {
    const mq = window.matchMedia("(pointer: fine) and (min-width: 1024px)");
    const sync = () => setOn(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);

  useEffect(() => {
    if (!on) return undefined;
    document.body.classList.add("custom-cursor-on");
    const move = (e) => { x.set(e.clientX); y.set(e.clientY); };
    const over = (e) => {
      const el = e.target.closest?.("[data-cursor], a, button");
      setState(el ? el.getAttribute("data-cursor") || "link" : "default");
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      document.body.classList.remove("custom-cursor-on");
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, [on, x, y]);

  if (!on) return null;
  const size = SIZES[state] || 14;
  const big = state === "view" || state === "play";
  return (
    <motion.div aria-hidden="true" data-testid="studio-cursor" style={{ x: sx, y: sy }} className="pointer-events-none fixed left-0 top-0 z-[90]">
      <motion.div animate={{ width: size, height: size }} transition={{ type: "spring", stiffness: 320, damping: 28 }}
        className={`-translate-x-1/2 -translate-y-1/2 flex items-center justify-center rounded-full transition-colors duration-300 ${STYLE[state] || STYLE.default}`}>
        {big && <span className="font-mono text-[10px] uppercase tracking-[0.18em]">Click to Play</span>}
      </motion.div>
    </motion.div>
  );
};
